/**
 * The document title, per page. A tab, a bookmark, the browser history, and
 * a screen reader's page announcement all read it, and before this every
 * page was "FunderGraph". The parts are the page's own name first and its
 * kind second, so a tab shows the organization, not the site.
 */
import { useEffect } from 'react';

export const SITE_NAME = 'FunderGraph';

export const pageTitle = (...parts: readonly (string | null | undefined)[]): string =>
  [...parts.filter((part): part is string => typeof part === 'string' && part.length > 0), SITE_NAME].join(' — ');

export const usePageTitle = (title: string): void => {
  useEffect(() => {
    document.title = title;
  }, [title]);
};
